import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryDraft.removeSupplementFromInquiryDraft;
export const removeSupplementFromInquiryDraftIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
